<template>
  <transition name="slide">
    <div class="hs-container-child" v-if="show">
      <c-header :title="$t('CheckInRules')" leftIcon1="return.png" :leftFn1="close">
      </c-header>
      <hs-section>
        <hs-cell-1 :showLogo="false">
          <div class="details">
            <div class="left">
              <p>{{$t('NumberOfRooms')}}</p>
            </div>
            <div class="right">
              <div class="content">
                <div class="logo" v-if="currtIntlRoomAmount > 1" @click="currtIntlRoomAmount--">
                  <p></p>
                </div>
                <div class="logo" v-else>
                  <p :style="{backgroundImage: `url(${require('@/assets/image/hotel/query/reduce_gray.png')})`}"></p>
                </div>
                <p>{{currtIntlRoomAmount}}</p>
                <div v-if="currtIntlRoomAmount < 9" class="logo" @click="currtIntlRoomAmount++">
                  <p :style="{backgroundImage: `url(${require('@/assets/image/hotel/query/add_balck.png')})`}"></p>
                </div>
                <div v-else class="logo">
                  <p :style="{backgroundImage: `url(${require('@/assets/image/hotel/query/add_gray.png')})`}"></p>
                </div>
              </div>
            </div>
          </div>
        </hs-cell-1>
        <hs-cell-1 :showLogo="false">
          <div class="details">
            <div class="left">
              <p>{{$t('NumberOfGuestsPerRoom')}}</p>
            </div>
            <div class="right">
              <div class="content">
                <div class="logo" v-if="currtIntlAdultAmount > 1" @click="currtIntlAdultAmount--">
                  <p></p>
                </div>
                <div class="logo" v-else>
                  <p :style="{backgroundImage: `url(${require('@/assets/image/hotel/query/reduce_gray.png')})`}"></p>
                </div>
                <p>{{currtIntlAdultAmount}}</p>
                <div v-if="currtIntlAdultAmount < 5" class="logo" @click="currtIntlAdultAmount++">
                  <p :style="{backgroundImage: `url(${require('@/assets/image/hotel/query/add_balck.png')})`}"></p>
                </div>
                <div v-else class="logo">
                  <p :style="{backgroundImage: `url(${require('@/assets/image/hotel/query/add_gray.png')})`}"></p>
                </div>
              </div>
            </div>
          </div>
        </hs-cell-1>
      </hs-section>
      <hs-gradient-button style="margin: 20px 0" :title="$t('Confirm_2')" @click="_gotoQuery"></hs-gradient-button>
    </div>
  </transition>
</template>

<script type="text/ecmascript-6">
export default {
  props: {
    intlRoomAmount: {
      type: Number,
      default: 1
    },
    intlAdultAmount: {
      type: Number,
      default: 2
    }
  },
  created() {},
  mounted() {},
  data () {
    return {
      show: false,
      currtIntlRoomAmount: 1,
      currtIntlAdultAmount: 2
    }
  },
  methods: {
    open() {
      this.show = true
      this._initCurrt()
    },
    close() {
      this.show = false
    },
    _initCurrt() {
      this.currtIntlRoomAmount = this.intlRoomAmount
      this.currtIntlAdultAmount = this.intlAdultAmount
    },
    _gotoQuery() {
      this.$emit('update:intlRoomAmount', this.currtIntlRoomAmount)
      this.$emit('update:intlAdultAmount', this.currtIntlAdultAmount)
      this.close()
    }
  },
  components: {
    CHeader: () => import('components/c-header/c-header'),
    HsCell1: () => import('base/hs-tableview/hs-cell-1/hs-cell-1'),
    HsGradientButton: () => import('base/hs-button/hs-gradient-button'),
    HsSection: () => import('base/hs-tableview/hs-section/hs-section')
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
.hs-container-child
  position absolute
  width 100%
  height 100%
  left 0
  top 0
  bottom 0
  background-color $color_gray_background_0
  z-index 200
  .details
    @extend .flex-row
    @extend .flex-between
    width 100%
    >.left
      font-size 1rem
      color $color_gray_text
    >.right
      width 120px
      >.content
        @extend .flex-row
        @extend .flex-between
        >.logo
          width 30px
          height 30px
          background $color_gray_layer
          border-radius 2px
          >p
            width 20px
            height 20px
            background-image url("@/assets/image/hotel/query/reduce_black.png")
            background-size 100% 100%
            margin 0 auto
            margin-top 5px
        >p
          width 30px
          font-size 1rem
          text-align center
          font-weight bold
</style>
